import {PlaceOrderWizard, placeOrderWizard} from "./PlaceOrderWizardComponent";
import {OrderConfirmStep, orderConfirmStep} from "./steps/confirm/single/OrderConfirmStepComponent";
import {RoaStep, roaStep} from "./steps/roa/RoaStepComponent";
import {OrderStep, orderStep} from "./steps/order/single/OrderStepComponent";
import {tmcOrderStep, TmcOrderStep} from "./steps/order/tmc/TmcOrderComponent";
import {orderConfirmTmcStep, OrderConfirmTmcStep} from "./steps/confirm/tmc/OrderConfirmTmcStepComponent";
import {tradeDetail, TradeDetail} from "./steps/order/single/trade/TradeOrderComponent";
import {portfolioImpact, PortfolioImpact} from "./steps/confirm/portfolio-impact/PortfolioImpactComponent";
import {orderMarginLimit, OrderMarginLimit} from "./steps/confirm/margin/OrderMarginLimitComponent";
import {marketHoursWarning, MarketHoursWarning} from "./steps/confirm/market-hours/MarketHoursWarningComponent";
import {DuplicateOrdersNotificationDialog} from "./dialog/DuplicateOrdersNotificationDialog";
import {disclaimerStep, DisclaimerStep} from "./steps/disclaimer/WizardDisclaimerStep";
import {childOrdersStep, ChildOrdersStep} from "./steps/child-orders/ChildOrdersStep";

const root = "app/portfolio/templates/ticket/place-order-wizard";

export default angular.module("tfApp.portfolio.order-wizard", [])
                      .component(PlaceOrderWizard, placeOrderWizard())
                      .component(OrderStep, orderStep())
                      .component(TradeDetail, tradeDetail())
                      .component(TmcOrderStep, tmcOrderStep())
                      .component(RoaStep, roaStep())
                      .component(OrderConfirmStep, orderConfirmStep())
                      .component(OrderConfirmTmcStep, orderConfirmTmcStep())
                      .component(PortfolioImpact, portfolioImpact())
                      .component(OrderMarginLimit, orderMarginLimit())
                      .component(MarketHoursWarning, marketHoursWarning())
                      .component(DisclaimerStep, disclaimerStep(root))
                      .component(ChildOrdersStep, childOrdersStep(root))
                      .service(DuplicateOrdersNotificationDialog.id, DuplicateOrdersNotificationDialog)
                      .name;
